import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
// import { DataGridPro } from "@mui/x-data-grid-pro";
import {
  Box,
  Chip,
  Tooltip,
  TextField,
  Button,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { toast } from "react-toastify";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PersonIcon from "@mui/icons-material/Person";
import CustomDataGridPro from "../../CustomDataGridPro";
import RightDrawer from "../../RightDrawer";
import authStore from "../../../stores/AuthStore";
import userStore from "../../../stores/UserStore";

const RegisteredUser = observer(() => {
  // const theme = useTheme();

  const [selectedUser, setSelectedUser] = useState(null);
  const [roleDialogOpen, setRoleDialogOpen] = useState(false);
  const [permissionDialogOpen, setPermissionDialogOpen] = useState(false);
  const [availableRoles, setAvailableRoles] = useState([]);
  const [availablePermissions, setAvailablePermissions] = useState([]);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    fetchAllPermissionsAndRoles();
  }, []);

  const fetchAllPermissionsAndRoles = async () => {
    const { roles, permissions } = await userStore.fetchRolePermLists();
    console.log("Permissions: ", permissions);

    setAvailableRoles(roles);
    setAvailablePermissions(permissions);
  };

  const rows = userStore.allUsers.filter((u) => u.active === true);

  const columns = [
    { field: "id", headerName: "ID", flex: 0.5, sortable: true },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      sortable: true,
      renderCell: (params) => {
        const currentUser = authStore.getUser();
        // console.log("Current user in all user tab: ", currentUser.name);
        const isMe = currentUser && params.row.name === currentUser.name;
        return (
          <span>
            {params.value} {isMe && "(you)"}
          </span>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1.5,
      sortable: true,
      //   filterOperators: stringOperators,
    },
    {
      field: "roles",
      headerName: "Roles",
      flex: 1.5,
      sortable: false,
      renderCell: ({ row }) => {
        const items = row.roles || [];
        const visible = items.slice(0, 2);
        const extraCount = items.length - visible.length;
        return (
          <Tooltip title={items.join(", ")}>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {visible.map((role) => (
                <Chip key={role} size="small" label={role} />
              ))}
              {extraCount > 0 && <Chip size="small" label={`+${extraCount}`} />}
            </Box>
          </Tooltip>
        );
      },
    },
    {
      field: "permissions",
      headerName: "Permissions",
      flex: 2,
      sortable: false,
      renderCell: ({ row }) => {
        const items = row.permissions || [];
        const visible = items.slice(0, 2);
        const extraCount = items.length - visible.length;
        return (
          <Tooltip title={items.join(", ")}>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {visible.map((perm) => (
                <Chip key={perm} size="small" label={perm} />
              ))}
              {extraCount > 0 && <Chip size="small" label={`+${extraCount}`} />}
            </Box>
          </Tooltip>
        );
      },
    },
    // {
    //   field: "emailVerified",
    //   headerName: "Email Verified",
    //   flex: 1,
    //   sortable: true,
    //   type: "boolean",
    // },
    {
      field: "active",
      headerName: "Active Status",
      flex: 0.8,
      sortable: true,
      type: "boolean",
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      sortable: false,
      renderCell: ({ row }) => (
        <Box>
          <Tooltip title="Edit">
            <IconButton
              size="small"
              sx={{
                mr: 1,
                color: "#22C55E",
                "&:hover": {
                  backgroundColor: "#BBF7D0",
                },
              }}
              onClick={(e) => {
                e.stopPropagation(); // ✅ prevents triggering row click
                setSelectedUser(row); // ✅ opens drawer
              }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              size="small"
              color="error"
              onClick={(e) => {
                e.stopPropagation(); // ✅ also prevent row click for delete
                handleDelete(row.id, row.email);
              }}
              sx={{
                color: "#6B7280",
                "&:hover": {
                  backgroundColor: "#E5E7EB",
                },
              }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  const handleUpdate = async () => {
    try {
      const updated = await userStore.updateUser({
        id: selectedUser.id,
        name: selectedUser.name,
        email: selectedUser.email,
        roles: selectedUser.roles,
        permissions: selectedUser.permissions,
        emailVerified: selectedUser.emailVerified,
        active: selectedUser.active,
        phone: selectedUser.phone,
        city: selectedUser.city,
        state: selectedUser.state,
        country: selectedUser.country,
      });

      userStore.allUsers = userStore.allUsers.map((u) =>
        u.id === updated.id ? updated : u
      );

      setSelectedUser(updated);
      await userStore.fetchAllUsers();
      toast.success("User updated successfully!");
      handleDrawerClose();
    } catch (err) {
      toast.error(err.message || "Failed to update user");
    }
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Delete "${name}"?`)) return;

    try {
      await userStore.deleteUser(id);
      toast.success("User deleted!");

      if (selectedUser?.id === id) {
        handleDrawerClose();
      }
    } catch (err) {
      toast.error(err.message || "Failed to delete user");
    }
  };

  const handleDrawerClose = () => setSelectedUser(null);

  return (
    <>
      {/* <DataGridPro
        rows={rows}
        columns={columns}
        getRowId={(row) => row.id}
        onRowClick={(params) => setSelectedUser(params.row)}
        disableColumnMenu={false}
        hideFooter
        disableSelectionOnClick
        loading={userStore.loading}
        sx={{
          flex: 1,
          minHeight: 0,
          "& .MuiDataGrid-columnHeaders, & .MuiDataGrid-columnHeader": {
            backgroundColor:
              theme.palette.mode === "dark" ? "#44475A" : "#F9FAFB",
          },
          "& .MuiDataGrid-columnHeaderTitle": { fontWeight: "bold" },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
            display: "flex",
            alignItems: "center",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: theme.palette.action.hover,
          },
          "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
            outline: "none",
          },
        }}
      /> */}

      <CustomDataGridPro
        rows={rows}
        columns={columns}
        getRowId={(row) => row.id}
        onRowClick={(params) => setSelectedUser(params.row)}
        page={page}
        setPage={setPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        totalCount={rows.length}
        isLoading={userStore.loading}
      />

      <RightDrawer
        open={!!selectedUser}
        onClose={handleDrawerClose}
        title={selectedUser?.name || "User Details"}
      >
        {selectedUser && (
          <Box
            component="form"
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              gap: 3,
              p: 2,
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
              <Box
                sx={{ border: `2px solid gray`, borderRadius: "50%", p: 1.5 }}
              >
                <PersonIcon sx={{ fontSize: 64 }} />
              </Box>
            </Box>
            <TextField
              label="Name"
              value={selectedUser.name || ""}
              fullWidth
              onChange={(e) =>
                setSelectedUser((prev) => ({
                  ...prev,
                  name: e.target.value,
                }))
              }
            />
            <TextField
              label="Email"
              value={selectedUser.email}
              fullWidth
              onChange={(e) =>
                setSelectedUser((prev) => ({
                  ...prev,
                  email: e.target.value,
                }))
              }
            />

            {/* Roles */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="subtitle2">Roles</Typography>
              <Button size="small" onClick={() => setRoleDialogOpen(true)}>
                Add Role
              </Button>
            </Box>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {(selectedUser.roles || []).map((role) => (
                <Chip key={role} label={role} size="small" />
              ))}
            </Box>

            {/* Permissions */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="subtitle2">Permissions</Typography>
              <Button
                size="small"
                onClick={() => setPermissionDialogOpen(true)}
              >
                Add Permission
              </Button>
            </Box>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {(selectedUser.permissions || []).map((perm) => (
                <Chip key={perm} label={perm} size="small" />
              ))}
            </Box>

            {/* User Details */}
            <TextField
              label="Phone"
              value={selectedUser.phone || ""}
              fullWidth
              onChange={(e) =>
                setSelectedUser((prev) => ({
                  ...prev,
                  phone: e.target.value,
                }))
              }
            />
            <TextField
              label="City"
              value={selectedUser.city || ""}
              fullWidth
              onChange={(e) =>
                setSelectedUser((prev) => ({ ...prev, city: e.target.value }))
              }
            />
            <TextField
              label="State"
              value={selectedUser.state || ""}
              fullWidth
              onChange={(e) =>
                setSelectedUser((prev) => ({
                  ...prev,
                  state: e.target.value,
                }))
              }
            />
            <TextField
              label="Country"
              value={selectedUser.country || ""}
              fullWidth
              onChange={(e) =>
                setSelectedUser((prev) => ({
                  ...prev,
                  country: e.target.value,
                }))
              }
            />

            <FormControl fullWidth>
              <InputLabel>Active</InputLabel>
              <Select
                label="Active"
                value={selectedUser.active ? "Yes" : "No"}
                onChange={(e) =>
                  setSelectedUser((prev) => ({
                    ...prev,
                    active: e.target.value === "Yes",
                  }))
                }
              >
                <MenuItem value="No">No</MenuItem>
                <MenuItem value="Yes">Yes</MenuItem>
              </Select>
            </FormControl>

            <TextField
              label="Created Date"
              value={selectedUser.createdDate || ""}
              fullWidth
              disabled
            />
            <TextField
              label="Updated Date"
              value={selectedUser.updatedDate || ""}
              fullWidth
              disabled
            />

            <Box
              sx={{
                mt: "auto",
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                pt: 2,
                borderTop: 1,
                borderColor: "divider",
              }}
            >
              <Button
                variant="contained"
                onClick={handleDrawerClose}
                className="px-6 py-2 rounded-lg !normal-case"
                sx={{
                  backgroundColor: "transparent",
                  color: "#6B7280",
                  border: "1px solid #6B7280",
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleUpdate}
                className="px-6 py-2 rounded-lg !normal-case"
                sx={{
                  backgroundColor: "#22C55E",
                  color: "#FFFFFF",
                }}
              >
                Update
              </Button>
            </Box>
          </Box>
        )}

        {/* Roles Dialog */}
        <Dialog
          open={roleDialogOpen}
          onClose={() => setRoleDialogOpen(false)}
          slotProps={{
            paper: {
              sx: {
                width: 400,
                height: 300,
              },
            },
          }}
        >
          <DialogTitle>Manage Roles</DialogTitle>
          <DialogContent>
            {availableRoles.map((role) => (
              <FormControlLabel
                key={role}
                control={
                  <Checkbox
                    checked={(selectedUser?.roles ?? []).includes(role)}
                    onChange={() => {
                      const has = selectedUser.roles.includes(role);
                      setSelectedUser((prev) => ({
                        ...prev,
                        roles: has
                          ? prev.roles.filter((r) => r !== role)
                          : [...prev.roles, role],
                      }));
                    }}
                  />
                }
                label={role}
              />
            ))}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setRoleDialogOpen(false)}>Cancel</Button>
            <Button onClick={() => setRoleDialogOpen(false)}>Save</Button>
          </DialogActions>
        </Dialog>

        {/* Permissions Dialog */}
        <Dialog
          open={permissionDialogOpen}
          onClose={() => setPermissionDialogOpen(false)}
          slotProps={{
            paper: {
              sx: {
                width: 400,
                height: 300,
              },
            },
          }}
        >
          <DialogTitle>Manage Permissions</DialogTitle>
          <DialogContent>
            {availablePermissions.map((perm) => (
              <FormControlLabel
                key={perm}
                control={
                  <Checkbox
                    checked={(selectedUser?.permissions ?? []).includes(perm)}
                    onChange={() => {
                      const has = selectedUser.permissions.includes(perm);
                      setSelectedUser((prev) => ({
                        ...prev,
                        permissions: has
                          ? prev.permissions.filter((p) => p !== perm)
                          : [...prev.permissions, perm],
                      }));
                    }}
                  />
                }
                label={perm}
              />
            ))}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setPermissionDialogOpen(false)}>
              Cancel
            </Button>
            <Button onClick={() => setPermissionDialogOpen(false)}>Save</Button>
          </DialogActions>
        </Dialog>
      </RightDrawer>
    </>
  );
});

export default RegisteredUser;
